// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RxBwh","delete":"styles_delete__VigLt","update":"styles_update__W7VvR","add":"styles_add__11ELU"};